import React from "react";

//The small dark label above each section heading ("SERVICES", "ABOUT"...)
const SectionTag = ({ children }) => (
  <span className={"section-tag"}>{children}</span>
);

export default SectionTag;
